module.exports = {
    title: '管理平台模板',

    /**
     * @type {boolean} true | false
     * @description Whether show the settings right-panel
     */
    showSettings: true,

    /**
     * @type {boolean} true | false
     * @description Whether show header
     */
    showHeader: true,

    /**
     * @type {boolean} true | false
     * @description Whether cache pages
     */
    cachePages: false,

    /**
     * @type {boolean} true | false
     * @description Whether show header-tabs
     */
    showTabs: false,

    /**
     * @type {boolean} true | false
     * @description Whether show header-tags
     */
    showTags: true,

    /**
     * @type {boolean} true | false
     * @description Whether fix the header
     */
    fixedHeader: false,

    /**
     * @type {boolean} true | false
     * @description Whether show the logo in sidebar
     */
    sidebarLogo: false,

    /**
     * @type {string | array} 'production' | ['production', 'development']
     * @description Need show err logs component.
     * The default is only used in the production env
     * If you want to also use it in dev, you can pass ['production', 'development']
     */
    errorLog: 'production'
}
